import React from 'react';
import { useHistory } from 'react-router-dom';
import { Menu, Dropdown } from 'antd';
import { RECORD_FIELD } from '@unicus/react-ui-kit';
import UserProfileImage from 'components/UserProfileImage';
import { useDispatch, useSelector } from 'react-redux';
import {
  updatePassword,
  currentUserGet,
  getMyPreferences
} from 'stores/users/userActions';

import UpdatePassword from 'pages/shared/UpdatePassword';
import CurrentUserEdit from 'pages/shared/CurrentUserEdit';
import CurrentUserMyPreferences from 'pages/shared/CurrentUserMyPreferences';
import useAuth from 'core/hooks/useAuth';
import { reducerName } from 'util/normalizers';
import usePermissions from 'core/hooks/usePermissions';
import { changeCompany, changeTenant } from 'stores/auth/authActions';
import PatientFinancialEntryList from 'pages/shared/PatientFinancialEntryList';
import CompanyEdit from 'pages/shared/CompanyEdit';
import { getCurrentProfessional } from 'stores/healthServiceProviders/healthServiceProviderActions';
import CurrentProfessionalEdit from 'pages/shared/CurrentProfessionalEdit';
import { useCustomHistory } from 'hooks';
import useSegmentField from 'core/hooks/useSegmentField';

const CurrentUserProfile = () => {
  const {
    user,
    isAdmin,
    isMultiTenant,
    tenantId,
    company,
    isMultiCompany
  } = useAuth();
  const {
    isProfessional,
    isStudent,
    isUserAdmin,
    isPartnership
  } = usePermissions();
  const dispatch = useDispatch();
  const history = useCustomHistory();
  const segmentFields = useSegmentField();
  const {
    editingCurrentUser,
    [RECORD_FIELD]: resourceUsers,
    myPreferences,
    saving
  } = useSelector((state) => state.resources.users || {});

  const signout = () => {
    history.push('/signout', false);
  };

  const handleEditProfile = () => {
    dispatch(currentUserGet(user.id));
  };

  const handleEditProfessional = () => {
    dispatch(getCurrentProfessional());
  };

  const handleUpdatePassword = () => {
    dispatch(updatePassword({ userId: user.id }));
  };

  const handleMyPreferences = () => {
    dispatch(getMyPreferences());
  };

  const handleMySubscription = () => {
    history.push('current-subscriptions');
  };

  const handleBackToRootTenant = () => {
    dispatch(
      changeTenant(null, () => {
        history.push('/a/accounts/professional-accounts', false);
      })
    );
  };

  const changeTenantClickHandle = () => {
    dispatch(
      changeTenant(null, () => {
        history.push('/accounts-chooser', false);
      })
    );
  };

  const changeCompanyClickHandle = () => {
    dispatch(
      changeCompany(null, () => {
        history.push('/accounts-chooser', false);
      })
    );
  };

  const userMenuOptions = (
    <Menu>
      <Menu.Item onClick={handleEditProfile}>Meus dados</Menu.Item>
      {isProfessional ? (
        <Menu.Item onClick={handleEditProfessional}>
          Meus dados profissionais
        </Menu.Item>
      ) : null}
      {segmentFields.isHealthcareEnabled && (isProfessional || isAdmin()) && (
        <Menu.Item onClick={handleMyPreferences}>Minhas preferências</Menu.Item>
      )}
      {(isUserAdmin || isPartnership || isAdmin()) && tenantId && (
        <Menu.Item onClick={handleMySubscription}>Minha assinatura</Menu.Item>
      )}
      {isMultiTenant && tenantId ? (
        <Menu.Item onClick={changeTenantClickHandle}>Trocar de conta</Menu.Item>
      ) : null}
      {isMultiCompany && company ? (
        <Menu.Item onClick={changeCompanyClickHandle}>
          Trocar de empresa
        </Menu.Item>
      ) : null}
      <Menu.Item onClick={handleUpdatePassword}>Alterar senha</Menu.Item>
      {isAdmin() && (
        <Menu.Item onClick={handleBackToRootTenant}>Administração</Menu.Item>
      )}
      <Menu.Item onClick={signout}>Sair</Menu.Item>
    </Menu>
  );

  const userName = user?.professionalName ?? user?.displayName ?? user?.name;
  const name = reducerName(userName);
  let profile = '';

  if (isStudent) {
    profile = ' (Estudante)';
  }

  if (isPartnership) {
    profile = ' (Parceiro)';
  }

  return (
    <>
      <Dropdown overlay={userMenuOptions} trigger={['click']}>
        <div className="gx-flex-row gx-align-items-center gx-avatar-row gx-flex-nowrap">
          <UserProfileImage
            className="gx-size-40 gx-pointer gx-mr-2"
            id={user.id}
            uri={user.profileImage?.uri}
          />

          <div className="gx-flex-nowrap">
            <div className="gx-flex-nowrap">
              <span className="gx-text-white">
                {name || <span style={{ color: '#ccc' }}>Carregando...</span>}
              </span>

              {profile && (
                <span className="gx-fs-11 gx-text-white gx-font-weight-bold">
                  {profile}
                </span>
              )}
            </div>

            <div>
              {company ? (
                <span className="gx-avatar-name gx-fs-11 gx-text-white">
                  {company.name}
                </span>
              ) : null}
            </div>
          </div>
          <i className="icon gx-text-white icon-chevron-down gx-fs-xxs gx-ml-2" />
        </div>
      </Dropdown>
      {editingCurrentUser ? <CurrentUserEdit /> : null}
      <CurrentProfessionalEdit />
      <PatientFinancialEntryList />
      <CompanyEdit />
      {resourceUsers && resourceUsers.editingPassword && (
        <UpdatePassword updatePassword={resourceUsers.editingPassword} />
      )}
      {myPreferences ? (
        <CurrentUserMyPreferences data={myPreferences} saving={saving} />
      ) : null}
    </>
  );
};

export default CurrentUserProfile;
